// extracted by mini-css-extract-plugin
export default {"flexAlign":"style_flexAlign__FCFsn","contentItem":"style_contentItem__3ZdIs","horizontal":"style_horizontal__TdDz2"};